import React, { useState, useEffect } from 'react';
import { ref, onValue, set } from 'firebase/database';
import { database } from './firebaseConfig';
import './HistoryPanel.css';

const HistoryPanel = ({ user, onSelectChat, onCreateNew }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const filteredHistory = history.filter(chat =>
    chat.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // determine anonymous status from provided user object
  const isAnonymous = user?.isAnonymous === true;


  useEffect(() => {
    if (!user || user.isAnonymous) {
      setHistory([]);
      setLoading(false);
      return;
    }

    const historyRef = ref(database, `users/${user.uid}/chatHistory`);
    
    const unsubscribe = onValue(historyRef, (snapshot) => {
      if (snapshot.exists()) {
        const chats = snapshot.val();
        const chatArray = Object.entries(chats).map(([id, chat]) => ({
          id,
          ...chat,
        })).sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
        
        setHistory(chatArray);
      } else {
        setHistory([]);
      }
      setLoading(false);
    }, (error) => {
      // Handle Firebase errors
      setHistory([]);
      setLoading(false);
    });

    // Cleanup listener on unmount or user change
    return () => unsubscribe();
  }, [user]);

  const saveChat = async (data) => {
  if (!user) return; // 🔒 hard stop

  await set(ref(database, `users/${user.uid}/chats/...`), data);
};

const [anonChats, setAnonChats] = useState([]);

const sendMessage = (text) => {
  if (isAnonymous) {
    // in anonymous mode we keep messages only locally
    setAnonChats(prev => [
      ...prev,
      {
        id: Date.now(),
        role: 'user',
        content: text
      }
    ]);
    return;
  }

  // logged-in user → save normally
};


  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    

    if (diffDays === 0) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } else if (diffDays === 1) {
      return 'Yesterday';
    } else if (diffDays < 7) {
      return `${diffDays}d ago`;
    } else {
      return date.toLocaleDateString();
    }
  };

  const createNewChat = async () => {
    if (!user || user.isAnonymous) return;
    const newId = ` ${Date.now()}`;
    const chatRef = ref(database, `users/${user.uid}/chatHistory/${newId}`);
    await set(chatRef, {
      title: 'New Chat',
      timestamp: Date.now(),
      plan: 'FREE',
    });
    if (onCreateNew) onCreateNew(newId);
  };

const openVSCodeExtensions = () => {
  // Replace 'my-extension' with the actual extension name you want to search
  const extensionName = 'my-extension';
  const vscodeUrl = `vscode://extensions/search?query=${extensionName}`;

  // Try opening VS Code via the custom protocol
  window.open(vscodeUrl, '_blank');
};



  const editChatName = async (chat) => {
    if (!user || user.isAnonymous) return;
    const newName = window.prompt('Enter new chat name:', chat.title || '');
    if (!newName) return;
    const nameRef = ref(database, `users/${user.uid}/chatHistory/${chat.id}/title`);
    await set(nameRef, newName);
  };

  const deleteChat = async (chat) => {
    if (!user || user.isAnonymous) return;
    if (!window.confirm('Delete this chat?')) return;
    const chatRef = ref(database, `users/${user.uid}/chatHistory/${chat.id}`);
    await set(chatRef, null);
  };

  return (
    <div className="history-panel">
      <div className="history-header">
        <button className="new-chat-btn" onClick={createNewChat}><i className="fas fa-plus"></i>New chart</button>
        <button className="new-chat-btn" onClick={openVSCodeExtensions}><i className="fas fa-plug"></i> Open VSCode Extension</button>

      </div>
      


<div className="history-search">
  <input
    type="text"
    placeholder="Search chats..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>

      <div className="history-list">
{loading ? (
  <p className="loading-text">Loading history...</p>
) : filteredHistory.length === 0 ? (
  <p className="empty-text">
    {searchTerm ? 'No chats match your search.' : 'No chats yet. Start a conversation!'}
  </p>
) : (
  filteredHistory.map((chat) => (
    <div key={chat.id} className="history-item">
              <div className="history-main" onClick={() => onSelectChat && onSelectChat(chat)}>
                <p className="history-title">{chat.title || 'Untitled Chat'}</p>
                <p className="history-time">{formatTime(chat.timestamp)}</p>
              </div>

              <div className="history-actions">
                <button className="edit-btn" onClick={() => editChatName(chat)}><i className="fas fa-edit"></i></button>
                <button className="delete-btn" onClick={() => deleteChat(chat)}><i className="fas fa-trash"></i></button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HistoryPanel;
